// extracted by mini-css-extract-plugin
module.exports = {"menu_div":"LeftMenu_menu_div__xsUX_","alarm_div1":"LeftMenu_alarm_div1__1tZa_","alarm_div2":"LeftMenu_alarm_div2__3VHt7"};